module.exports = __webpack_public_path__ + "img/banking-providers.4856ab5.webp";